import { i18n } from '@/plugins/i18n'
import { subcategories } from '@/constants/subcategories'
import { gatewayStatusStr, gatewayVariant } from '@/constants/gatewayStatus'

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'full_name',
        title: i18n.t('label.user_full_name'),
        sortable: false,
        template: (row) => {
            return '<a href="/users/' + row.user.id + '/details">'+row.user.full_name+'</a>'
        },
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('label.gateway_title'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'site_address',
        title: i18n.t('label.site_address'),
        sortable: false,
        template: (row) => '<span dir="ltr">'+row.site_address+'</span>',
        width: 120,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: false,
        template: (row) => '<span dir="ltr">'+row.created_at+'</span>',
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'status',
        sortable: true,
        title: i18n.t('label.status'),
        template: (row) => {
            let status  = gatewayStatusStr.get(row.status)
            let variant = 'badge-'+gatewayVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'has_limit',
        sortable: false,
        title: i18n.t('label.limit'),
        template: (row) => {
            let variant   = row.has_limit ? 'badge-danger' : 'badge-success'
            let has_limit = row.has_limit ? i18n.t('limit.limited') : i18n.t('limit.unlimited')

            return '<div class="badge '+variant+' text-white">'+ has_limit+'</div>'
        },
        width: 80,
        textAlign: 'center',
    },
]